let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lntWI")).then(() => parcelRequire('7dmMn'));